import { useContext, useState } from "react";
import { GlobalContext } from "global/context/Provider";
import { showToaster } from "global/context/action/toaster/toaster";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import CardBlueHeart from "_+_Portal/_-_Autocheckin/components/genericos/CardBlueHeart/CardBlueHeart";
import PasoBar from "_+_Portal/_-_Autocheckin/components/genericos/PasoBar/PasoBar";
import FirmaOrden from "_+_Portal/_-_Autocheckin/components/genericos/FirmaOrden/FirmaOrden";
import { wsPostOrdenConFirmaDigital } from "_+_Portal/context/Actions/ordenEstudio/ordenEstudio";
import { PortalContext } from "_+_Portal/context/Provider";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { setRuta } from "_+_Portal/_-_Autocheckin/context/action/ruta";
import { setIdTipoPuntoControl } from "_+_Portal/_-_Autocheckin/context/action/puntoControl";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import { proximoPaso } from "../PagesFun";
import { ContainerFirmaOrdenDigital } from "./localStyle";

const FirmaOrdenDigital = ({ turnoActual, setLoading }) => {
  const { toasterDispatch } = useContext(GlobalContext);
  const { ordenEstudioDispatch } = useContext(PortalContext);
  const {
    turnosSeleccionadosState,
    rutaState,
    pasoDispatch,
    rutaDispatch,
    puntoControlDispatch,
  } = useContext(AutocheckContext);

  const listTurnosSeleccionado =
    turnosSeleccionadosState.turnosSeleccionados?.data ?? [];
  const turno = listTurnosSeleccionado[turnoActual];

  const [enviando, setEnviando] = useState(false);

  // Avanza al siguiente paso de la ruta ya armada por SeleccionOrden
  // (ValidarCobertura? / AbonarMP? / TurnoProximo).
  const avanzarRuta = () => {
    const nuevaRuta = [...rutaState.ruta.data];
    setRuta(proximoPaso(nuevaRuta, setPaso, pasoDispatch))(rutaDispatch);
  };

  const enviarPuntoControl = () => {
    setLoading(true);
    setIdTipoPuntoControl(5)(puntoControlDispatch);
    setPaso("PuntoControl")(pasoDispatch);
  };

  // Reusa el endpoint POST his/turnos/ordenConFirmaDigital/true con ordenDigital=true.
  // El handler backend salta UploadImagesAsync y solo guarda la firma como documento
  // tipo 512 en TURNODOCUMENTOS (ver SubirOrdenConFirmaDigitalCommandHandler.cs).
  const finalizarProceso = (dto, type) => {
    if (type !== "firmaOrden" || enviando) return;

    setEnviando(true);
    setLoading("Guardando firma...");

    const objFinal = {
      firmaDigitalDto: { id: turno.idturno, descripcion: dto.binario },
      listMediaDto: [],
    };

    wsPostOrdenConFirmaDigital(objFinal, true, (isCorrect) => {
      if (!isCorrect) {
        setEnviando(false);
        setLoading(false);
        showToaster(
          {
            texto: "No se pudo guardar la firma. Pasá por mostrador.",
            tipo: "danger",
          },
          "centroArriba",
        )(toasterDispatch);
        enviarPuntoControl();
        return;
      }
      avanzarRuta();
    })(ordenEstudioDispatch);
  };

  return (
    <LayoutPasos
      volverTo={"/autocheckin/resumen"}
      handleClick={() => setPaso("TurnosDelDia")(pasoDispatch)}
      type={"no-circle"}
      title={"firma de la orden"}
      children={
        <>
          <Loading
            dataLoading={enviando}
            descripcion="Cargando..."
            color={"c-white"}
          />
          <CardBlueHeart
            medico={turno?.medico ? turno.medico : turno?.especialidad}
            turnoTitle={turno?.especialidad}
            pasoActual={turnoActual + 1}
            pasoTotal={listTurnosSeleccionado.length}
          />
          <ContainerFirmaOrdenDigital>
            <PasoBar paso={"SubirOrden"} />
            <FirmaOrden
              finalizarProceso={finalizarProceso}
              idTurno={turno?.idturno}
            />
          </ContainerFirmaOrdenDigital>
        </>
      }
    />
  );
};

export default FirmaOrdenDigital;
